"use strict";
const { isUs, isEu } = require('../auth/consts');
const getMasterServiceData = () => {
    let selfServiceMasterServiceId = '200';
    let selfServiceTeamId = '12049';
    if (isUs) {
        selfServiceMasterServiceId = '25594';
        selfServiceTeamId = '1371';
    }
    if (isEu) {
        selfServiceMasterServiceId = '51002';
        selfServiceTeamId = '6998';
    }
    return { MASTER_SERVICE_ID: selfServiceMasterServiceId, DEFAULT_MASTER_SERVICE_TEAM_ID: selfServiceTeamId };
};
const { MASTER_SERVICE_ID, DEFAULT_MASTER_SERVICE_TEAM_ID } = getMasterServiceData();
const DEFAULT_MASTER_SERVICE_TEAM_NAME = 'Customer Success Team';
const { PUBLIC_MARKETPLACE_ENDPOINT } = process.env;
module.exports = {
    MASTER_SERVICE_ID,
    DEFAULT_MASTER_SERVICE_TEAM_ID,
    DEFAULT_MASTER_SERVICE_TEAM_NAME,
    PUBLIC_MARKETPLACE_ENDPOINT,
};
//# sourceMappingURL=consts.js.map